import { RouteRecordRaw, RouteLocationNormalizedLoadedGeneric } from 'vue-router';

export const promotionRouters: RouteRecordRaw[] = [
  {
    path: '/promotion',
    name: 'Promotion',
    component: () => import('@/pages/h5/Promotion/Promotion.vue'),
    meta: { title: '推广', disabledNavBar: true },
  },
  {
    path: '/personal-promote/:type?',
    name: 'PersonalPromote',
    component: () => import('@/pages/h5/Promotion/Children/PersonalPromote/index.vue'),
    meta: { title: '个人推广' },
  },
  {
    path: '/invitingAgent',
    name: 'invitingAgent',
    component: () => import('@/pages/h5/inviting/invitingAgent.vue'),
    meta: { title: '成为代理人', disabledNavBar: true },
  },
  {
    path: '/agentsMaterial',
    name: 'agentsMaterial',
    component: () => import('@/pages/h5/inviting/agentsMaterial.vue'),
    // meta: { title: '成为代理人' },
    meta: {
      title: (routeData: RouteLocationNormalizedLoadedGeneric) =>
        routeData.query.mode === 'realName' ? '实名认证' : '成为代理人',
    },
  },
  {
    path: '/promotePerformance',
    name: 'PromotePerformance',
    component: () => import('@/pages/h5/Promotion/Children/PromotePerformance.vue'),
    meta: {
      title: (routeData: RouteLocationNormalizedLoadedGeneric) => {
        return Number(routeData.query.pageType) === 1 ? '个人推广数据' : '拓展推广数据';
      },
    },
  },
  {
    path: '/accumuExpanNum',
    name: 'AccumuExpanNum',
    component: () => import('@/pages/h5/Promotion/Children/AccumuExpanNum.vue'),
    meta: {
      title: '累计拓展人数',
    },
  },
  {
    path: '/commission-detail/:pageType',
    name: 'CommissionDetail',
    component: () => import('@/pages/h5/Commission/CommissionDetail/CommissionDetail.vue'),
    meta: {
      title: (routeData: RouteLocationNormalizedLoadedGeneric) => {
        const titleList: Record<string, string> = {
          1: '累计佣金收益',
          2: '累计佣金提现',
          3: '累计佣金扣除',
        };
        const curType = (routeData.params.pageType || '-1') as string;
        return titleList[curType] || '数据详情';
      },
    },
  },
  {
    path: '/inviteReportCount',
    name: 'InviteReportCount',
    component: () => import('@/pages/h5/Promotion/Children/InviteReportCount.vue'),
    meta: {
      title: '我代理的直推报告',
    },
  },
  {
    path: '/inviteSub',
    name: 'InviteSub',
    component: () => import('@/pages/h5/Promotion/Children/InviteSub.vue'),
    meta: {
      title: '邀请下级代理人',
    },
  },
  {
    path: '/markupSetting',
    name: 'MarkupSetting',
    component: () => import('@/pages/h5/inviting/markupSetting.vue'),
    meta: { title: '加价设置' },
  },
  {
    path: '/applyMaterial',
    name: 'ApplyMaterial',
    component: () => import('@/pages/h5/Promotion/Children/ApplyMaterial/index.vue'),
    meta: { title: '物料申请' },
  },
  {
    path: '/propertyPerformance',
    name: 'PropertyPerformance',
    component: () => import('@/pages/h5/Property/Children/PromotePerformance.vue'),
    meta: {
      title: (routeData: RouteLocationNormalizedLoadedGeneric) => {
        return Number(routeData.query.pageType) === 1 ? '个人推广数据' : '拓展推广数据';
      },
    },
  },
  {
    path: '/accumuExpanNum',
    name: 'AccumuExpanNum',
    component: () => import('@/pages/h5/Promotion/Children/AccumuExpanNum.vue'),
    meta: {
      title: '累计拓展人数',
    },
  },
];
